module.exports = __webpack_public_path__ + "img/shopping-bag-512.d2c7ad06.png";